<template>
  <svg :width="width" :height="height" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M18 3V1H16V3H8V1H6V3H4C2.89543 3 2 3.89543 2 5V21C2 22.1046 2.89543 23 4 23H20C21.1046 23 22 22.1046 22 21V5C22 3.89543 21.1046 3 20 3H18ZM20 5V7H4V5H20ZM4 21V9H20V21H4Z"
      :fill="color"
    />
    <path
      d="M12 11C12.4103 11 12.7484 11.3088 12.7946 11.7067L12.8 11.8V14.2H15.2C15.6418 14.2 16 14.5582 16 15C16 15.4103 15.6912 15.7484 15.2933 15.7946L15.2 15.8H12.8V18.2C12.8 18.6418 12.4418 19 12 19C11.5897 19 11.2516 18.6912 11.2054 18.2933L11.2 18.2V15.8H8.8C8.35817 15.8 8 15.4418 8 15C8 14.5897 8.30883 14.2516 8.7067 14.2054L8.8 14.2H11.2V11.8C11.2 11.3582 11.5582 11 12 11Z"
      :fill="color"
    />
  </svg>
</template>

<script lang="ts">
export default {
  name: 'AddAvailabilityIcon',
  props: {
    width: {
      type: Number,
      default: 24,
    },
    height: {
      type: Number,
      default: 24,
    },
    color: {
      type: String,
      default: '#99005c',
    },
  },
};
</script>
